import {Button} from '@mui/material';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import Box from '@mui/material/Box';
import {LoadingButton} from '@mui/lab';
import PropsType from 'prop-types';

const UploadButton = ({
  isLoading,
  functionToRun,
  disabled,
  isUploadCompleted,
  hasSuccessfulData,
}) => {
  return (
    <>
      <AppsHeader>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              ml: 'auto',
            }}
          >
            {isLoading ? (
              <LoadingButton loading variant='outlined' disabled>
                Upload Files
              </LoadingButton>
            ) : (
              <Button
                variant='contained'
                color='primary'
                onClick={functionToRun}
                disabled={disabled}
              >
                {isUploadCompleted && !hasSuccessfulData
                  ? 'Upload Complete - Select New File'
                  : 'Upload Files'}
              </Button>
            )}
          </Box>
        </Box>
      </AppsHeader>
    </>
  );
};

UploadButton.propTypes = {
  isLoading: PropsType.bool.isRequired,
  functionToRun: PropsType.func.isRequired,
  disabled: PropsType.bool,
  isUploadCompleted: PropsType.bool,
  hasSuccessfulData: PropsType.bool,
};

export default UploadButton;
